import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEscape);
    }
    return () => {
      window.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-147">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50" onClick={onClose} data-id="element-148" />

          {/* Modal */}
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-149">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} className="bg-navy-lighter border-2 border-gold/30 rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-150">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-gold/20" data-id="element-151">
                <h2 className="text-2xl md:text-3xl font-heading font-black text-gold-metallic" data-id="element-152">
                  {title}
                </h2>
                <button onClick={onClose} className="p-2 hover:bg-gold/10 rounded-lg transition-colors" aria-label="Cerrar modal" data-id="element-153">
                  <XIcon className="w-6 h-6 text-gold" data-id="element-154" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-88px)]" data-id="element-155">
                {children}
              </div>
            </motion.div>
          </div>
        </>}
    </AnimatePresence>;
}